export const LANGUAGE_KEY = 'selectedLanguage';
export const SETTINGS_SILENT_VISIBLE_KEY = 'settingsSilentVisible';
export const SETTING_ENABLED = '1';
export const SETTING_DISABLED = '0';
export const EMPTY_IMAGE_URL = '/images/noimage.png';
export const ONE_HOUR_MS = 3600 * 1000;
export const TOOLTIP_Z_INDEX = 1299;
